import { CONFIG } from 'src/config-global';

// ----------------------------------------------------------------------

export const _workspaces = [
  {
    id: '',
    name: 'All Agencies',
    logo: `${CONFIG.site.basePath}/assets/icons/workspaces/logo-1.webp`,
    plan: '*',
  },
  {
    id: 'TODO: show from api',
    name: 'Agency 1',
    logo: `${CONFIG.site.basePath}/assets/icons/workspaces/logo-1.webp`,
    plan: 'Tier 1',
  },
  {
    id: 'TODO: show from api 2',
    name: 'Team 2',
    logo: `${CONFIG.site.basePath}/assets/icons/workspaces/logo-2.webp`,
    plan: 'VIP',
  },
  {
    id: 'TODO: show from api 3',
    name: 'Agency Jupiter',
    logo: `${CONFIG.site.basePath}/assets/icons/workspaces/logo-3.webp`,
    plan: 'VIP',
  },
];
